module.exports = __webpack_public_path__ + "static/media/galerija_2023 (3).92d21321.png";